
<mat-expansion-panel class="study-dicom">
    <mat-expansion-panel-header class="study-header">
        <div class="header">
            <div class="row">
                <!-- Action -->
                <div class="col-action">
                    <mat-checkbox (click)="preventAccordionClick($event)"
                                  (ngModelChange)="toggle()"
                                  [disabled]="study.status.sendingStatus === 'SENT'"
                                  [ngModel]="study.status.selected"
                                  color="primary">
                    </mat-checkbox>
                </div>

                <div class="col-action-delete">
                    <button (click)="onDelete($event)"
                            mat-icon-button
                            matTooltip="Delete">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>

                <div class="col-feedback">
                    <feedback (delete)="onDeleteStudy()" [status]="study.status"></feedback>
                </div>

                <!-- PId -->
                <div class="col-pid">
                    <p>{{study.data.patient.id  || '--'}}</p>
                </div>

                <!-- Patient -->
                <div class="col-patient">
                    <p>{{study.data.patient.name  || '--'}}</p>
                    <p>{{ study.data.patient.birthDate ? (study.data.patient.birthDate | date: 'dd/MM/YYYY') : '--' }}</p>
                    <p>{{study.data.patient.sex  || '--'}}</p>
                </div>

                <!-- Description -->
                <div class="col-description">{{study.data.description}}</div>

                <!-- Accession Number -->
                <div class="col-acc-number">
                    <p>{{study.data.accessionId || '--'}}</p>
                    <p>{{'Series' | translate}} : {{study.data.series.length}}</p>
                    <p>{{'Files' | translate}} : {{study.data.filesNumber}}</p>
                </div>

                <!-- Date -->
                <p>{{ study.data.date ? (study.data.date | date: 'dd/MM/YYYY') : '--' }} {{study.data.time }}</p>

                <!-- Modality -->
                <div class="col-modality">{{joinedModalities}}</div>

            </div>
        </div>
    </mat-expansion-panel-header>
    <div *ngFor="let series of study.data.series; let islast = last">
        <div [ngClass]="{'last-series': islast}">
            <series [series]="series" ></series>
        </div>
    </div>
</mat-expansion-panel>



